var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.dialogVisible,
        title: "首次登录请修改密码",
        width: "520px",
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "show-close": false,
        "append-to-body": "",
        "custom-class": "first-login-pwd-dialog",
      },
    },
    [
      _c("p", { staticClass: "tip-text" }, [
        _vm._v(
          "\n    为保障账号安全，请先完成登录密码修改后再使用系统其他功能。请使用绑定手机接收验证码进行校验，并设置新密码。\n  "
        ),
      ]),
      _vm._v(" "),
      _c(
        "el-form",
        {
          ref: "form",
          attrs: {
            model: _vm.loginForm,
            rules: _vm.rules,
            "label-width": "100px",
          },
        },
        [
          _c("el-form-item", { attrs: { label: "手机号码" } }, [
            _c("span", [_vm._v(_vm._s(_vm.agentInfo.phone || "—"))]),
          ]),
          _vm._v(" "),
          _vm.checkRoles(["terminal"])
            ? _c(
                "el-form-item",
                { attrs: { label: "旧密码", prop: "old_pwd" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "password",
                      "show-password": "",
                      autocomplete: "current-password",
                    },
                    model: {
                      value: _vm.loginForm.old_pwd,
                      callback: function ($$v) {
                        _vm.$set(_vm.loginForm, "old_pwd", $$v)
                      },
                      expression: "loginForm.old_pwd",
                    },
                  }),
                ],
                1
              )
            : _c(
                "el-form-item",
                { attrs: { label: "验证码", prop: "captche_num" } },
                [
                  _c(
                    "div",
                    { staticClass: "flex" },
                    [
                      _c("el-input", {
                        attrs: { autocomplete: "one-time-code" },
                        model: {
                          value: _vm.loginForm.captche_num,
                          callback: function ($$v) {
                            _vm.$set(_vm.loginForm, "captche_num", $$v)
                          },
                          expression: "loginForm.captche_num",
                        },
                      }),
                      _vm._v(" "),
                      _c("auth-code", {
                        ref: "authCode",
                        staticClass: "ml-10",
                        on: { authCode: _vm.getAuthCode },
                      }),
                    ],
                    1
                  ),
                ]
              ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "新密码", prop: "cur_pwd" } },
            [
              _c("el-input", {
                attrs: {
                  type: "password",
                  "show-password": "",
                  autocomplete: "new-password",
                },
                model: {
                  value: _vm.loginForm.cur_pwd,
                  callback: function ($$v) {
                    _vm.$set(_vm.loginForm, "cur_pwd", $$v)
                  },
                  expression: "loginForm.cur_pwd",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "确认密码", prop: "re_pwd" } },
            [
              _c("el-input", {
                attrs: {
                  type: "password",
                  "show-password": "",
                  autocomplete: "new-password",
                },
                model: {
                  value: _vm.loginForm.re_pwd,
                  callback: function ($$v) {
                    _vm.$set(_vm.loginForm, "re_pwd", $$v)
                  },
                  expression: "loginForm.re_pwd",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.submitting },
                  on: { click: _vm.onSubmit },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }